module.exports = __webpack_public_path__ + "img/icon-esim-detail-coverage-arrow-light.9e7d408.svg";